import { IdentificationModel } from '@/models';

export interface IdentificationState {
  identification: IdentificationModel | null
}

export const InitialState: IdentificationState = {
  identification: null
}
